export { default as CredentialsValidationStore } from './CredentialsValidationStore';



// WEBPACK FOOTER //
// ./src/modules/credentials-validation/stores/index.js